import { atom } from "recoil";
import { IconName } from "../components/Icon";

export type SnackbarInfo = {
    icon?: IconName | null;
    text: string;
    mode?: "primary" | "secondary" | "success" | "error" | "info" | "warning";
    timeout?: number;
    _id: string; // for internal use
    _removed?: boolean; // for internal use
    _height?: number; // for internal use
    onRemove?: () => void;
};

export const snackbarStackAtom = atom<SnackbarInfo[]>({
    key: "snakbar",
    default: [],
});
